import { render } from "./SettingsAccountSection.vue?vue&type=template&id=70c425a1"
import script from "./SettingsAccountSection.vue?vue&type=script&lang=js"
export * from "./SettingsAccountSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__